'use client';

import { useCallback, useEffect, useRef, useState } from 'react';
interface UseAdWatchTimerOptions {
  onComplete?: () => void;
}
interface UseAdWatchTimerReturn {
  elapsed: number;
  isRunning: boolean;
  start: () => void;
  stop: () => void;
  reset: () => void;
}
export const useAdWatchTimer = ({
  onComplete
}: UseAdWatchTimerOptions = {}): UseAdWatchTimerReturn => {
  const [elapsed, setElapsed] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;
  const clearTimer = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);
  const start = useCallback(() => {
    clearTimer();
    setIsRunning(true);
    intervalRef.current = setInterval(() => {
      setElapsed(prev => prev + 1);
    }, 1000);
  }, [clearTimer]);
  const stop = useCallback(() => {
    clearTimer();
    setIsRunning(false);
  }, [clearTimer]);
  const reset = useCallback(() => {
    clearTimer();
    setIsRunning(false);
    setElapsed(0);
  }, [clearTimer]);
  useEffect(() => {
    return clearTimer;
  }, [clearTimer]);
  return {
    elapsed,
    isRunning,
    start,
    stop,
    reset
  };
};